(function($){
    function jobsOpen() {
        var $jobButton = $('.job_button-js');

        $jobButton.click(function() {
            var $currentButton = $(this);
            var $currentContentJobs = $(this).next('.jobs_item_content');

            if ($currentButton.hasClass('active')) {
                $currentButton.removeClass('active');
                $currentContentJobs.removeClass('active');
            } else {
                $currentButton.addClass('active');
                $currentContentJobs.addClass('active');
            }
        });
    }

    function menu_open() {
        $('.burger_button-js').click(function(){
            $('.menu_burger').removeClass('menu_burger_closing').addClass('menu_burger_open');
            $('body').toggleClass('bg_blur');
            return false;
        });
    }

    function menu_close() {
        $('.menu_close-js').click(function(){
            $('.menu_burger').removeClass('menu_burger_open').addClass('menu_burger_closing');
            $('body').removeClass('bg_blur');
            return false;
        });

        $(document).click(function(event) {
            if (!$(event.target).closest('.menu_burger_wrapper_nav').length) {
                $('.menu_burger').removeClass('menu_burger_open').addClass('menu_burger_closing');
                $('body').removeClass('bg_blur');
            }
        });
    }

    function project_scroll() {
        if (window.innerWidth >= 992) {
            let contentElements = gsap.utils.toArray(".project_trigger-js .project_link-js");
            let scrollTween = gsap.to(contentElements, {
                xPercent: -100 * (contentElements.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: ".project_trigger-js",
                    pin: true,
                    scrub: 0.4,
                    end: "+=4000"
                }
            });
        }
    }

    function team_scroll() {
        let contentElementsTeam = gsap.utils.toArray(".team_content");
        let blockTeam = document.querySelector(".team_trigger-js");
        if(contentElementsTeam && blockTeam) {
            if (window.innerWidth >= 992) {
                let blockTeam = document.querySelector(".team_trigger-js");
                let totalWidth = 0;
                contentElementsTeam.forEach(el => totalWidth += el.offsetWidth);

                // distance réelle à parcourir = totalWidth - largeur visible du container
                let distance = totalWidth - blockTeam.offsetWidth;

                gsap.to(contentElementsTeam, {
                    x: - distance - 400,
                    ease: "none",
                    scrollTrigger: {
                        trigger: blockTeam,
                        pin: true,
                        scrub: 0.4,
                        end: "+=" + distance
                    }
                });
            }
        }
    }

    function SliderTestimonials() {
        const SliderTestimonials = document.getElementById('testimonial_slider');
        if(SliderTestimonials) {
            new Splide(SliderTestimonials, {
                type       : 'slide',
                perPage    : 2,
                perMove    : 1,
                arrows     : true,
                pagination : false,
                gap        : '20px',
                speed      : 300,
                autoHeight: true,
                breakpoints: {
                    768: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }

    function sliderGallery() {
        const sliderGallery = document.querySelectorAll('.gallery_slider-js');
        if(sliderGallery.length > 0) {
            sliderGallery.forEach(slider => {
                new Splide(slider, {
                    type       : 'slide',
                    perPage    : 1,
                    perMove    : 1,
                    arrows     : false,
                    pagination : true,
                    speed      : 500,
                }).mount();
            });
        }
    }

    function moveCup() {
        document.querySelectorAll('.cta_img_cup').forEach(btn=>{
            btn.addEventListener('mousemove', (e)=>{
                const rect = btn.getBoundingClientRect();
                const h = rect.width / 2;
                const x = e.clientX - rect.left - h;
                const y = e.clientY - rect.top - h;
                const r1 = Math.sqrt(x * x + y * y);
                const r2 = (1 - (r1 / h)) * r1;
                const angle = Math.atan2(y, x);
                const tx = Math.round(Math.cos(angle) * r2 * 100) / 100;
                const ty = Math.round(Math.sin(angle) * r2 * 100) / 100;
                const op = (r2 / r1) + 0.25;

                btn.style.setProperty('--tx', `${tx}px`);
                btn.style.setProperty('--ty', `${ty}px`);
                btn.style.setProperty('--opacity', `${op}`);
            });

            btn.addEventListener('mouseleave', (e)=>{
                btn.style.setProperty('--tx', '0px');
                btn.style.setProperty('--ty', '0px');
                btn.style.setProperty('--opacity', `${0.25}`);
            });
        })
    }

    function txtBanner() {
        const txtBanner = document.querySelector('.txt-banner');
        if (txtBanner) {
            const txtBannerWidth = txtBanner.offsetWidth;
            gsap.to('.txt-banner, .txt-banner-copy', {
                x: -txtBannerWidth,
                ease: "linear",
                repeat: -1,
                duration: 25,
            });
        }
    }

    function marques() {
        let marqueeText = document.querySelector('.marquee-projet p');

        if (marqueeText) {
            let width = marqueeText.offsetWidth;
            let container = document.querySelector('.marquee-projet');
            
            if (container) {
                let containerWidth = container.offsetWidth;
                let repeatTimes = Math.ceil(containerWidth / width) + 1;
                
                marqueeText.innerHTML = marqueeText.textContent.repeat(repeatTimes);
                
                gsap.set(marqueeText, { x: 0 });
                
                gsap.to(marqueeText, {
                    x: `-${width}px`,
                    ease: "linear",
                    repeat: -1,
                    duration: 20,
                });
            }
        } 
    }

    function waitForLogoCookieAndHide() {
    const logoCookie = document.querySelector('.cky-btn-revisit-wrapper');
    
    if (logoCookie) {
        setTimeout(function() {
        logoCookie.style.display = 'none';
        }, 10000);
    } else {
        setTimeout(waitForLogoCookieAndHide, 500);
    }
    };

    function nbrJobsMenu() {
        const menuCareerTab = document.querySelector('.menu_career a');
        if (menuCareerTab) {
            const span = document.createElement('span');
            span.textContent = '5';
            menuCareerTab.parentNode.appendChild(span);
        }
    }

	function jobsFormContact() {
		const titleJob     = document.getElementById('titleJob');
		const titleContact = document.getElementById('titleContact');
		const job          = document.getElementById('job');
		const jobInput     = document.querySelector('.jobInput input');

		// Obtenez la chaîne de requête de l'URL actuelle
		const queryString = window.location.search;

		// Créez un objet URLSearchParams
		const urlParams = new URLSearchParams(queryString);

		const jobParam = urlParams.get('job'); 

		if (titleJob && jobInput) {
			if (jobParam) {
				const jobName = replaceUnderscores(jobParam);
				job.innerText = jobName;
				titleContact.remove();
				setTimeout(() => {
					jobInput.value = jobName;
				}, 600);
			} else {
				titleJob.remove();
				jobInput.remove();
			}
		}

		function replaceUnderscores(str) {
			// Remplacer les doubles underscores __ par ' / '
			let result = str.replace(/__/g, ' / ');
			// Remplacer les underscores simples _ par des espaces
			result = result.replace(/_/g, ' ');
			return result;
		}
	}

    function projectsFitler() {
        const buttons = document.querySelectorAll('.project_filter .project_filter_btn-js');
        const projects = document.querySelectorAll('.project_link-js');

        if(buttons) {
            buttons.forEach(btn => {
                btn.addEventListener('click', () => {
                    buttons.forEach(b => b.classList.remove('active'));
                    btn.classList.toggle('active');

                    const filter = btn.getAttribute('data-filter');

                    projects.forEach(p => {
                        if (filter === 'all' || p.classList.contains(filter)) {
                            p.classList.add('project_active-js');
                        } else {
                            p.classList.remove('project_active-js');
                        }
                    });
                });
            });
        }
    }

    function sliderLogos() {
        const swiperContainer = document.querySelector('.logos_swiper-js');

        if (!swiperContainer) return;

        // Swiper désactive la boucle s'il n'y a pas assez de slides : on duplique les logos
        const wrapper = swiperContainer.querySelector('.swiper-wrapper');
        const originals = Array.from(wrapper.children);
        const minSlides = 7 * 2 + 2;

        if (originals.length) {
            while (wrapper.children.length < minSlides) {
                originals.forEach(slide => wrapper.appendChild(slide.cloneNode(true)));
            }
        }

        const swiper = new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 7,
            speed: 5000,
            spaceBetween: 40,
            autoplay: {
                delay: 0,
                enabled: true,
            },
            breakpoints: {
                // écran ≤ 768px
                0: {
                    slidesPerView: 2,
                },
                // écran ≥ 769px
                769: {
                    slidesPerView: 5,
                },
                1200: {
                    slidesPerView: 7,
                }
            },
        });
    }

    function popupForm() {
        const popup    = document.getElementById("popup_form");
        const closeBtn = document.getElementById("popup_form_close");
        const form     = document.getElementById("mc-embedded-subscribe-form");

        let hideTimeout;
        const storageKey = "popup_form_closed"; // clé unique et cohérente

        if (popup) {
            const hasInteracted = localStorage.getItem(storageKey);

            function hidePopup() {
                popup.classList.add("popup_form_hidden");
            }

            function startHideTimer() {
                clearTimeout(hideTimeout);
                hideTimeout = setTimeout(() => {
                    hidePopup();
                }, 15000); // 15 secondes
            }

            // n’affiche que si l’utilisateur n’a jamais fermé ou soumis
            if (!hasInteracted) {
                setTimeout(() => {
                    popup.classList.remove("popup_form_hidden");
                    startHideTimer(); // lancement du timer
                }, 5000);
            }

            // Reset du timer si hover seulement
            popup.addEventListener("mouseenter", startHideTimer);

            // Fermer la popup
            if (closeBtn) {
                closeBtn.addEventListener("click", () => {
                    hidePopup();
                    localStorage.setItem(storageKey, "closed"); // marque comme fermé
                    clearTimeout(hideTimeout);
                });
            }

            // Soumission du formulaire
            if (form) {
                form.addEventListener("submit", function () {
                    hidePopup();
                    localStorage.setItem(storageKey, "subscribed"); // marque comme soumis
                    clearTimeout(hideTimeout);
                });
            }
        }
    }

    if (typeof wpcf7 !== 'undefined') {
        document.addEventListener('wpcf7mailsent', function(event) {
            if(event.detail.contactFormId == 39) {
                window.location.href = '/merci-contact';
            }
        }, false);
    }

    // Begin playing audio
    let activeAudio = null;
    let previewAudio = null;

    function audioSystem() {
        const body = document.body;

        document.querySelectorAll('.audio_object').forEach(card => {
            const index = card.dataset.index;
            const audio = document.getElementById('audio' + index);
            if (!audio) return;

            /* =========================
            CLICK = lecture principale
            ========================== */
            card.addEventListener('click', (e) => {

                e.stopPropagation(); // bloque le click global pour cette carte

                // 🔁 Toggle sur le même audio
                if (activeAudio === audio) {
                    audio.pause();
                    audio.currentTime = 0;
                    card.classList.remove('playing');
                    body.classList.remove('audio-active');
                    activeAudio = null;
                    return;
                }

                // ⛔ Stop tous les autres audio
                if (activeAudio) {
                    activeAudio.pause();
                    activeAudio.currentTime = 0;
                }

                document.querySelectorAll('.audio_object')
                    .forEach(c => c.classList.remove('playing'));

                // 🔥 Stop preview si elle existe
                if (previewAudio) {
                    previewAudio.pause();
                    previewAudio.currentTime = 0;
                    previewAudio = null;
                }

                // ⏯ Play l’audio sélectionné
                audio.volume = 1;
                audio.play().catch(err => console.log(err));

                card.classList.add('playing');
                body.classList.add('audio-active');
                activeAudio = audio;
            });

            /* =========================
            HOVER = preview
            ========================== */
            card.addEventListener('mouseenter', () => {
                if (activeAudio) return; // Bloque preview si un audio principal joue

                if (audio.readyState >= 1) {
                    const middle = audio.duration / 2;
                    const variation = (Math.random() - 0.5) * 10;
                    const startTime = Math.max(0, middle + variation);

                    audio.currentTime = startTime;
                    audio.volume = 0.4;
                    audio.play().catch(err => console.log(err));

                    previewAudio = audio;
                }
            });

            card.addEventListener('mouseleave', () => {
                if (activeAudio) return;

                if (previewAudio === audio) {
                    audio.pause();
                    audio.currentTime = 0;
                    previewAudio = null;
                }
            });

            /* =========================
            Quand audio se termine
            ========================== */
            audio.addEventListener('ended', () => {
                if (activeAudio === audio) {
                    card.classList.remove('playing');
                    body.classList.remove('audio-active');
                    activeAudio = null;
                }
            });
        });

        /* =========================
        CLIC GLOBAL = stop audio si click en dehors des cartes
        ========================== */
        document.addEventListener('click', (e) => {
            if (!activeAudio) return;

            // Si le click est **sur une carte**, on ne fait rien
            if (e.target.closest('.audio_object')) return;

            // Sinon, stop l’audio actif
            activeAudio.pause();
            activeAudio.currentTime = 0;
            document.querySelectorAll('.audio_object')
                .forEach(c => c.classList.remove('playing'));
            body.classList.remove('audio-active');
            activeAudio = null;
        });
    }
    // Stop playing audio

    // Begin Like audio
    function audioLikes() {
        document.querySelectorAll('.audio_object_like_button').forEach(button => {

            const wrapper = button.closest('.audio_object_like');
            const musicId = wrapper.dataset.id;
            const storageKey = 'liked_music_' + musicId;

            // Etat au chargement
            if (localStorage.getItem(storageKey) === 'true') {
                button.classList.add('liked');
            }

            button.addEventListener('click', () => {

                const isLiked = localStorage.getItem(storageKey) === 'true';

                fetch(myAjax.ajax_url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: new URLSearchParams({
                        action: 'music_like',
                        music_id: musicId,
                        liked: isLiked ? 0 : 1
                    })
                })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {

                        wrapper.querySelector('.audio_object_like_count').textContent = data.data.count;

                        if (isLiked) {
                            button.classList.remove('liked');
                            localStorage.removeItem(storageKey);
                        } else {
                            button.classList.add('liked');
                            localStorage.setItem(storageKey, 'true');
                        }
                    }
                });

            });
        });
    }
    // End Like audio

    // Begin Bar control audio
    function controlBarAudio() {
        document.querySelectorAll('.audio_object').forEach(card => {
            const audio = card.querySelector('audio');
            const seekBar = card.querySelector('.audio_object_bar');

            if (!audio) return;

            // 🔹 Mettre à jour la barre de progression pendant la lecture
            audio.addEventListener('timeupdate', () => {
                const progress = (audio.currentTime / audio.duration) * 100;
                seekBar.value = progress || 0;
            });

            // 🔹 Changer la position en glissant la barre
            seekBar.addEventListener('input', () => {
                audio.currentTime = (seekBar.value / 100) * audio.duration;
            });
        });
    }
    // End Bar control audio

    // Begin game Page 404
    function page404game() {
        const gridEl       = document.getElementById('grid');
        const startScreen  = document.getElementById('snake-start');
        const gameoverEl   = document.getElementById('snake-gameover');
        const hudEl        = document.getElementById('snake-hud');
        const scoreEl      = document.getElementById('snake-score');
        const finalScore   = document.getElementById('snake-final-score');
        const btnStart     = document.getElementById('snake-btn-start');
        const btnRestart   = document.getElementById('snake-btn-restart');

        if (!gridEl) return;

        const WIDTH      = 20;
        const TOTAL      = WIDTH * WIDTH;
        const SPEED      = 150;

        let cells = [];
        let snake, direction, food, gameLoop, score;

        // ── Construit la grille une seule fois ──────────────────────
        function buildGrid() {
            gridEl.innerHTML = '';
            cells = [];
            for (let i = 0; i < TOTAL; i++) {
            const cell = document.createElement('div');
            cell.classList.add('cell');
            gridEl.appendChild(cell);
            cells.push(cell);
            }
        }

        // ── Place la nourriture ─────────────────────────────────────
        function placeFood() {
            const empty = cells.map((_, i) => i).filter(i => !snake.includes(i));
            food = empty[Math.floor(Math.random() * empty.length)];
            cells[food].classList.add('food');
        }

        // ── Démarre / redémarre une partie ─────────────────────────
        function startGame() {
            buildGrid();

            snake     = [Math.floor(TOTAL / 2)];
            direction = 1;
            score     = 0;

            cells[snake[0]].classList.add('snake');
            placeFood();

            scoreEl.textContent = 0;

            startScreen.style.display  = 'none';
            gameoverEl.style.display   = 'none';
            hudEl.style.display        = 'flex';
            gridEl.style.display       = 'grid';
            document.body.classList.add('overflow-hidden');

            gameLoop = setInterval(moveSnake, SPEED);
        }

        // ── Fin de partie ───────────────────────────────────────────
        function endGame() {
            clearInterval(gameLoop);
            finalScore.textContent    = score;
            gridEl.style.display      = 'none';
            hudEl.style.display       = 'none';
            gameoverEl.style.display  = 'flex';
            document.body.classList.remove('overflow-hidden');
        }

        // ── Logique de déplacement ──────────────────────────────────
        function moveSnake() {
            const head = snake[0] + direction;

            const hitLeft   = direction === 1    && snake[0] % WIDTH === WIDTH - 1;
            const hitRight  = direction === -1   && snake[0] % WIDTH === 0;
            const hitTop    = direction === -WIDTH && head < 0;
            const hitBottom = direction === WIDTH  && head >= TOTAL;

            if (snake.includes(head) || hitLeft || hitRight || hitTop || hitBottom) {
            endGame();
            return;
            }

            snake.unshift(head);
            cells[head].classList.add('snake');

            if (head === food) {
            score++;
            scoreEl.textContent = score;
            placeFood();
            } else {
            const tail = snake.pop();
            cells[tail].classList.remove('snake');
            }
        }

        // ── Contrôles clavier ───────────────────────────────────────
        document.addEventListener('keydown', e => {
            const map = {
            ArrowLeft:  -1,
            ArrowRight:  1,
            ArrowUp:    -WIDTH,
            ArrowDown:   WIDTH,
            };
            const next = map[e.key];
            if (!next) return;
            // interdit le demi-tour
            if (next + direction !== 0) direction = next;
        });

        // ── Boutons ─────────────────────────────────────────────────
        btnStart.addEventListener('click', () => {
            startGame();
        });

        btnRestart.addEventListener('click', () => {
            startGame();
        });
    }
    // End game Page 404

    window.addEventListener('unhandledrejection', function(event) {
        // Ignore les rejets "null"
        if(event.reason === null) {
            event.preventDefault();
            return;
        }
        console.warn('Unhandled promise rejection:', event.reason);
    });

    window.addEventListener('load', team_scroll);
    window.addEventListener('load', project_scroll);
    window.addEventListener('resize', function() {
        ScrollTrigger.getAll().forEach(st => st.kill());
        gsap.killTweensOf('.team_content');
        team_scroll();
        project_scroll();
    });

    $(document).ready(function() {
        jobsOpen();
        menu_open();
        menu_close();
    });

    jQuery(document).on('gform_post_render', function(event, formId){
        if (formId == 1) {
            jobsFormContact();
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        txtBanner();
        marques();
        nbrJobsMenu();
        waitForLogoCookieAndHide();
        sliderGallery();
        moveCup();
        SliderTestimonials();
        projectsFitler();
        sliderLogos();
        popupForm();
        audioSystem();
        audioLikes();
        controlBarAudio();
        page404game();

        /* Begin - Read page */
        const button = document.getElementById('readPageButton-js');
        if(button) {
            const labelPlay = button.querySelector('.label-play');
            const labelPause = button.querySelector('.label-pause');
        }

        let utter = null;

        function speakPage() {
            const text = document.body.innerText;
            utter = new SpeechSynthesisUtterance(text);
            utter.lang = 'fr-FR';

            utter.onend = function() {
                resetButton();
            };

            speechSynthesis.speak(utter);
        }

        function showPause() {
            button.classList.add('is-playing');
            button.classList.remove('is-playing');
        }

        function showPlay() {
            if(labelPlay && labelPause) {
                labelPlay.style.display = "inline";
                labelPause.style.display = "none";
            }
        }

        function resetButton() {
            showPlay();
        }

        if(button) {
            button.addEventListener('click', function () {

                if (!speechSynthesis.speaking) {
                    speechSynthesis.cancel(); // sécurité
                    speakPage();
                    showPause();
                }

                else if (speechSynthesis.speaking && !speechSynthesis.paused) {
                    speechSynthesis.pause();
                    labelPause.textContent = "Reprendre";
                }

                else if (speechSynthesis.paused) {
                    speechSynthesis.resume();
                    labelPause.textContent = "Mettre en pause";
                }
            });
        }
        /* End - Read page */

        if (typeof gsap !== "undefined") {

            if(typeof ScrollTrigger !== "undefined") {
                gsap.registerPlugin(ScrollTrigger);
            }

            const txtMoving = document.querySelector('.txt-moving-js .teaser_title');
            if (txtMoving) {
                gsap.fromTo(
                    ".txt-moving-js .teaser_title",
                    {
                        x: "30%" // position de départ (plus à droite)
                    },
                    {
                        x: "-45%", // position finale (vers la gauche)
                        ease: "none",
                        scrollTrigger: {
                            trigger: ".txt-moving-js",
                            start: "0% 50%",
                            end: "80% 50%",
                            scrub: 1,
                        }
                    }
                );
            }

            const txtBanner = document.querySelector('.text_infinity-js');
            if (txtBanner) {
                gsap.to(".text_infinity-js", {
                    scrollTrigger: {
                    trigger: ".text_infinity-js",
                    start: "top 80%",
                    end: "10% 78%",
                    scrub: .5,
                    },
                    rotation: -2,
                    ease: "ease",
                });
            }
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        const oeilNoirs = document.querySelectorAll('.header_oeil_noir');
        const links = document.querySelectorAll('.header_openeyes, a');
        let scheduledAnimationFrame = false;
        let mouseX = 0;
        let mouseY = 0;

        function updateEyePosition() {
            const minX = 42;
            const maxX = 100;
            const rangeX = maxX - minX;
            const minY = 70;
            const maxY = 100;
            const rangeY = maxY - minY;

            oeilNoirs.forEach(function(oeilNoir) {
                const xPosition = (mouseX / window.innerWidth) * 100;
                const yPosition = (mouseY / window.innerHeight) * 100;
                const newXPosition = minX + (xPosition / 100) * rangeX;
                const newYPosition = minY + (yPosition / 100) * rangeY;
                oeilNoir.style.left = `calc(${newXPosition}% - 9px)`;
                oeilNoir.style.top = `calc(${newYPosition}% - 9px)`;
            });

            scheduledAnimationFrame = false;
        }

        document.addEventListener('mousemove', function(e) {
            mouseX = e.clientX;
            mouseY = e.clientY;

            if (!scheduledAnimationFrame) {
                requestAnimationFrame(updateEyePosition);
                scheduledAnimationFrame = true;
            }
        });

        links.forEach(link => {
            link.addEventListener('mouseover', () => {
                oeilNoirs.forEach(pupil => {
                    pupil.classList.add('header_oeil_link-js');
                });
            });

            link.addEventListener('mouseout', () => {
                oeilNoirs.forEach(pupil => {
                    pupil.classList.remove('header_oeil_link-js');
                });
            });
        });
    });

})(jQuery); 